// extracted by mini-css-extract-plugin
module.exports = {"list_card_item":"ListCardItem_list_card_item__T2Pr5"};